import {VideoTileSkeletonDefaultbox} from "./video-tile-skeleton.defaultbox";

export const VideoTileSkeletonbox = VideoTileSkeletonDefaultbox;
